import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { FAQS } from "@/lib/siteConfig";
import { HelpCircle } from "lucide-react";

export const FAQSection = () => {
  return (
    <section id="faq" data-testid="faq-section" className="ss-section bg-slate-50">
      <div className="ss-container">
        <div className="grid lg:grid-cols-[1fr_1.4fr] gap-10 items-start">
          <div className="lg:sticky lg:top-24">
            <span className="ss-eyebrow">FAQ</span>
            <h2 className="ss-h2 mt-4 text-slate-900">Häufig gestellte Fragen</h2>
            <p className="ss-lead mt-4">
              Sie haben eine Frage, die hier nicht steht? Rufen Sie uns direkt an – wir beraten Sie ohne Formular und ohne Umwege.
            </p>
            <div className="mt-6 inline-flex items-center gap-2 text-sm text-slate-600">
              <HelpCircle className="h-4 w-4 text-[#EAB308]" />
              <span>Antworten auf einen Blick</span>
            </div>
          </div>

          <Accordion
            type="single"
            collapsible
            className="space-y-3"
            data-testid="faq-accordion"
            defaultValue="faq-0"
          >
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="rounded-2xl border border-slate-200 bg-white px-5 sm:px-6 shadow-[0_4px_16px_rgba(2,6,23,0.04)] data-[state=open]:shadow-[0_10px_30px_rgba(2,6,23,0.08)]"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger
                  className="text-left font-display text-base sm:text-lg font-semibold text-slate-900 hover:no-underline py-5"
                  data-testid={`faq-trigger-${i}`}
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 text-sm sm:text-base leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
